// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBfEp1mSzlEjR-oRwRqcp41TXJXQaxBb5I",
  authDomain: "salmaa-85b1c.firebaseapp.com",
  projectId: "salmaa-85b1c",
  storageBucket: "salmaa-85b1c.firebasestorage.app",
  messagingSenderId: "699460651769",
  appId: "1:699460651769:web:3aa17134735eea13947028",
  measurementId: "G-VN1ZSMRETW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
